/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react"
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    SheetRendererNote_note$data
} from "ui/feature/piece-play/common/sheet-renderer/__generated__/SheetRendererNote_note.graphql";
import SheetRendererNoteBox from "ui/feature/piece-play/common/sheet-renderer/SheetRendererNoteBox";
import {NoteDisplayState} from "ui/feature/piece-play/common/PlayTypes";

interface Props {
    currentSheetId: string;
    note: SheetRendererNote_note$data;
    pageHeight: number;
    pageWidth: number;
    state: NoteDisplayState;
}

const SheetRendererNote: React.FC<Props> = ({currentSheetId, pageHeight, state, pageWidth, note}) => {

    if (note.sheet_id !== currentSheetId) {
        return null;
    }

    return (
        <>
            {note.boxes.map((box, idx) => <SheetRendererNoteBox state={state} pageHeight={pageHeight} pageWidth={pageWidth} key={idx} box={box as any} />)}
        </>
    )
}

export default createFragmentContainer(SheetRendererNote, {
    note: graphql`
    fragment SheetRendererNote_note on MusicPieceFileNote {
        bulb_id
        sheet_id: page_id
        boxes {
            ...SheetRendererNoteBox_box
        }
    }
    `
});
